// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { DnsZoneRecordWithRelationsSchema } from './DnsZoneRecordRelationsSchema'
import type { DnsZoneRecordWithRelations } from './DnsZoneRecordRelationsSchema'
import { ExternalNetworkDnsZonePolicyWithRelationsSchema } from './ExternalNetworkDnsZonePolicyRelationsSchema'
import type { ExternalNetworkDnsZonePolicyWithRelations } from './ExternalNetworkDnsZonePolicyRelationsSchema'
import { DnsZoneSchema } from './DnsZoneSchema';

/////////////////////////////////////////
// DNS ZONE RELATION SCHEMA
/////////////////////////////////////////

export type DnsZoneRelations = {
  records: DnsZoneRecordWithRelations[];
  policies: ExternalNetworkDnsZonePolicyWithRelations[];
};

export type DnsZoneWithRelations = z.infer<typeof DnsZoneSchema> & DnsZoneRelations

export const DnsZoneWithRelationsSchema: z.ZodType<DnsZoneWithRelations> = DnsZoneSchema.merge(z.object({
  records: z.lazy(() => DnsZoneRecordWithRelationsSchema).array(),
  policies: z.lazy(() => ExternalNetworkDnsZonePolicyWithRelationsSchema).array(),
}))